import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Box, Container, Step, StepContent, StepLabel, Stepper, StepConnector, Typography, Button, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import NoDetailsInfo from '../../ui-component/no-details-info/NoDetailsInfo';
import { PAGES_URLS } from '../../../lib/constants/routes';
import { CheckIfUserAndOrganisationExist, RegisterUserAndOrganisation } from '../../../lib/api/AuthUser';
import ScrollToTop from '../../layout/ScrollToTop';
import LoadingBackdrop from '../../ui-component/loading/LoadingBackdrop';
import { cloneDeep } from 'lodash';
import { set } from 'lodash';
import PersonDaten from './person-daten/PersonDatan';
import OrganisationDaten from './organisation-daten/OrganisationDaten';
import LoginDaten from './login-daten/LoginDaten';
import AbschlussRegistrierung from './abschluss/AbschlussRegistrierung';
import PersonDatenValidator from './person-daten/PersonDatenValidator';
import OrganisationDatenValidator from './organisation-daten/OrganistaionDatenValidator';
import LoginDatenValidator from './login-daten/LoginDatenValidator';
import { ArrowBack } from '@mui/icons-material';
import NachRegistrierung from './abschluss/NachRegistrierung';

import UserSchema from '../../../lib/paths/user_Paths.json';
import PersonSchema from '../../../lib/paths/person_FULL_Paths.json';
// import OrgaSchema from '../../../lib/paths/unternehmen_FULL_Paths.json'
import { isTrue } from '../../../utils/helper';
const U_P = UserSchema.attributes;
const P_P = PersonSchema.attributes;
// const OP_P = OrgaSchema.attributes;

const steps = [
	{
		label: 'Personendaten',
		innerSteps: [],
	},
	{
		label: 'Angaben zur Organisation',
		innerSteps: [],
	},
	{
		label: 'Ihre Zugangsdaten',
		innerSteps: [],
	},
	{
		label: 'Überprüfung',
		innerSteps: [],
	},
];

const innerStepsLabelStyle = {
	fontSize: '14px',
};

const Register: FC<{}> = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const registrierungAls = get(location, 'state.registrierenAls');

	// const [hasFormEdited, setHasFormEdited] = useState(false);

	const [scrollToTop, setScrollToTop] = useState(false);
	const [activeStep, setActiveStep] = useState(0);

	const [loading, setLoading] = useState(false);
	const [isRegistrationSuccess, setIsRegistrationSuccess] = useState<boolean | null>(null);
	const [formErrorMessage, setFormErrorMessage] = useState('');

	const [personDaten, setPersonDaten] = useState({});
	const [personDatenError, setPersonDatenError] = useState({});
	const [organisationDaten, setOrganisationDaten] = useState({});
	const [datenschutzZustimmung, setDatenschutzZustimmung] = useState({ zustimmung: false });
	const [organisationDatenError, setOrganisationDatenError] = useState({});
	const [loginDaten, setLoginDaten] = useState({});
	const [loginDatenError, setLoginDatenError] = useState({});

	const handleUpdatePersonDaten = (key: string, value: any) => {
		// setHasFormEdited(true);
		let formValueCopy = cloneDeep(personDaten);
		set(formValueCopy, key, value);
		setPersonDaten(formValueCopy);
		let errorObject = cloneDeep(personDatenError);
		delete errorObject[key];
		setPersonDatenError(errorObject);

		if (get(formValueCopy, P_P.Kontaktdaten_E_Mail.path, '')) {
			setLoginDaten((prevValue: any) => ({
				...prevValue,
				[U_P.email.path]: get(formValueCopy, P_P.Kontaktdaten_E_Mail.path, ''),
			}));
		}
		setFormErrorMessage('');
		setScrollToTop(false);
	};
	const handleUpdateOrganisationDaten = (key: string, value: any) => {
		// setHasFormEdited(true);
		let formValueCopy = cloneDeep(organisationDaten);
		// if (key === OP_P.Unternehmensprofil_U_St_Id_Nr.path) value = value.trim();
		set(formValueCopy, key, value);
		setOrganisationDaten(formValueCopy);
		let errorObject = cloneDeep(organisationDatenError);
		delete errorObject[key];
		setOrganisationDatenError(errorObject);
		setFormErrorMessage('');
		setScrollToTop(false);
	};
	const handleUpdateLoginDaten = (key: string, value: any) => {
		// setHasFormEdited(true);
		let formValueCopy = cloneDeep(loginDaten);
		set(formValueCopy, key, value);
		setLoginDaten(formValueCopy);
		let errorObject = cloneDeep(loginDatenError);
		delete errorObject[key];
		setLoginDatenError(errorObject);
		setFormErrorMessage('');
		setScrollToTop(false);
	};
	const handleUpdateDatenschutzZustimmung = (key: string, value: any) => {
		let formValueCopy = cloneDeep(datenschutzZustimmung);
		set(formValueCopy, key, value);
		setDatenschutzZustimmung(formValueCopy);
	};

	const validatePersonData = () => {
		let errorObject = {};
		let errs = PersonDatenValidator.validate(personDaten);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setPersonDatenError(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const validateOrganisationData = () => {
		let errorObject = {};
		let errs = OrganisationDatenValidator.validate(organisationDaten);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setOrganisationDatenError(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const validateLoginData = () => {
		let errorObject = {};
		let errs = LoginDatenValidator.validate(loginDaten);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setLoginDatenError(errorObject);
		return Object.keys(errorObject).length === 0;
	};

	const handleBack = () => {
		setScrollToTop(true);
		setActiveStep(activeStep - 1);
	};

	const handleNext = async () => {
		setScrollToTop(true);
		switch (activeStep) {
			case 0:
				if (validatePersonData()) {
					setActiveStep(1);
				}
				break;
			case 1:
				if (validateOrganisationData()) {
					try {
						await CheckIfUserAndOrganisationExist(organisationDaten);
						setActiveStep(2);
					} catch (err: any) {
						console.error('Error checking Organisation ', err);
						setFormErrorMessage('Organisation existiert bereit');
					}
				}
				break;
			case 2:
				if (validateLoginData()) {
					if (get(loginDaten, U_P.password.path) !== get(loginDaten, U_P.repeatPassword.path)) {
						setLoginDatenError((prevValue) => ({
							...prevValue,
							[U_P.repeatPassword.path]: 'Beide Passwörter stimmen nicht überein.',
						}));
					} else {
						try {
							await CheckIfUserAndOrganisationExist(organisationDaten, loginDaten);
							setActiveStep(3);
						} catch (err: any) {
							console.error('Error checking Perosn', err);
							setFormErrorMessage('Person existiert bereit');
						}
					}
				}
				break;
			default:
				break;
		}
	};

	const handleReigstration = async () => {
		try {
			setScrollToTop(true);
			setLoading(true);
			let res = await RegisterUserAndOrganisation(organisationDaten, loginDaten, personDaten);
			if (res) {
				setIsRegistrationSuccess(true);
			}
		} catch (err: any) {
			setIsRegistrationSuccess(false);
			console.error(' ERROR: Registration ', err);
		} finally {
			setLoading(false);
			setActiveStep(4);
		}
	};

	useEffect(() => {
		const unloadCallback = (event: any) => {
			event.preventDefault();
			event.returnValue = '';
			return '';
		};
		window.addEventListener('beforeunload', unloadCallback);
		return () => window.removeEventListener('beforeunload', unloadCallback);
	}, []);

	if (registrierungAls !== 'KMU') {
		return <NoDetailsInfo title="Registrierungsoption" goBackUrl={PAGES_URLS.RegistrierungVorschritt} />;
	}
	return (
		<>
			<LoadingBackdrop open={loading} />
			{scrollToTop && <ScrollToTop />}

			<Container>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant="h2" component={'h1'}>
						Registrierung
					</Typography>
					<Button variant={'outlined'} startIcon={<ArrowBack />} onClick={() => navigate(PAGES_URLS.Login)}>
						{' '}
						Zurück zur Login-Seite
					</Button>
				</Stack>
			</Container>
			<RegistrierungWrapper>
				<FormStepper activeStep={activeStep} />
				<Box sx={{ flex: '1 1 71.25rem', display: 'flex', justifyContent: 'flex-start' }}>
					<Box
						component="form"
						sx={{
							width: '100%',
							maxWidth: '71.25rem',
							padding: '0 0 1.875rem',
							margin: { mobile: '0 auto', desktop: 'unset' },
						}}
					>
						{activeStep === 0 && (
							<>
								<PersonDaten
									formValue={personDaten}
									updateFunction={handleUpdatePersonDaten}
									personDatenError={personDatenError}
								/>
							</>
						)}

						{activeStep === 1 && (
							<>
								<OrganisationDaten
									formValue={organisationDaten}
									updateFunction={handleUpdateOrganisationDaten}
									organisationDatenError={organisationDatenError}
									formErrorMessage={formErrorMessage}
								/>
							</>
						)}

						{activeStep === 2 && (
							<>
								<LoginDaten
									formValue={loginDaten}
									updateFunction={handleUpdateLoginDaten}
									loginDatenError={loginDatenError}
									formErrorMessage={formErrorMessage}
								/>
							</>
						)}

						{activeStep === 3 && (
							<>
								<AbschlussRegistrierung
									formValue={datenschutzZustimmung}
									updateFunction={handleUpdateDatenschutzZustimmung}
									personDaten={personDaten}
									organisationDaten={organisationDaten}
									LoginDaten={loginDaten}
								/>
							</>
						)}

						{activeStep === 4 && <NachRegistrierung isRegistrationSuccess={isRegistrationSuccess} />}

						{/**
							Logics for Navigation Buttons
							*/}
						<Box sx={{ mt: '3rem' }}>
							{activeStep === 3 ? (
								<Stack direction="row" justifyContent="space-between">
									<Button variant="outlined" onClick={handleBack}>
										Zurück
									</Button>
									<Button
										variant="contained"
										onClick={handleReigstration}
										disabled={!isTrue(get(datenschutzZustimmung, 'zustimmung'))}
									>
										Jetzt registrieren
									</Button>
								</Stack>
							) : (
								<React.Fragment>
									{activeStep < 3 && (
										<Stack direction={'row'} justifyContent="space-between">
											<Button variant="outlined" disabled={activeStep === 0} onClick={handleBack}>
												Zurück
											</Button>
											<Button variant="contained" onClick={handleNext}>
												Weiter
											</Button>
										</Stack>
									)}
								</React.Fragment>
							)}
						</Box>
					</Box>
				</Box>
			</RegistrierungWrapper>
		</>
	);
};

export default Register;

const RegistrierungWrapper: FC<{ children: ReactNode }> = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				width: '100%',
				padding: '0 1.875rem',
				margin: 'auto',
				boxSizing: 'border-box',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: { mobile: 'strech', desktop: 'baseline' },
					width: '100%',
					minHeight: '100px',
					flexDirection: { mobile: 'column', desktop: 'row' },
					mt: '2rem',
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

const FormStepper: FC<{ activeStep: number }> = ({ activeStep }) => {
	return (
		<Box
			sx={{
				textAlign: 'left',
				marginBottom: '2rem',
				display: 'flex',
				flex: 1,
				flexDirection: 'column',
				alignItems: { mobile: 'center', desktop: 'flex-end' },
			}}
		>
			<Stepper activeStep={activeStep} orientation="vertical">
				{steps.map((ele: any, i: number) => {
					return (
						<Step key={i}>
							<StepLabel>
								<Typography>{ele.label}</Typography>
							</StepLabel>
							<StepContent>
								<Box>
									<Stepper activeStep={i} orientation="vertical">
										{ele.innerSteps.map((label: string, index: number) => {
											const stepProps = {};
											const labelProps = {};

											return (
												<Step key={index} {...stepProps}>
													<StepLabel {...labelProps}>
														<Typography sx={innerStepsLabelStyle}>{label}</Typography>
													</StepLabel>
													<StepConnector
														sx={{
															display: 'none',
														}}
													></StepConnector>
												</Step>
											);
										})}
									</Stepper>
								</Box>
							</StepContent>
						</Step>
					);
				})}
			</Stepper>
		</Box>
	);
};
